import { pass, fail, skip } from "../buildResult";
import { defineTest } from "../defineTest";
import { getDotPhrasesCount, isDotPhrasesEmpty } from "../helper/patientFields";

export default defineTest("dot_phrases_present", "Dot phrases", ({ patient }) => {
  if (!patient?.patient_id) return skip("No patient record");

  if (isDotPhrasesEmpty(patient.macros)) {
    return fail(
      "Dot phrases are missing",
      "patient.macros is null, empty, or has no applied dot phrases in postgres"
    );
  }

  const count = getDotPhrasesCount(patient.macros);
  return pass(`${count} dot phrase${count === 1 ? "" : "s"} present`);
});
